import { memo, useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from '@betty/toolkit/state';
import {
  fetchDailyScratcher,
  launchDailyScratcher,
  selectDailyScratcherLaunchUrl,
  selectDailyScratcherPlayerRewardId,
  selectDailyScratcherStatus,
  triggerAnimatedCoins,
} from '../../state';
import { Screen, useNavigation } from '@betty/navigation';
import { BettyCoinLoader, Box, WebView, PressableIcon } from '@betty/moonlight';
import { Platform } from 'react-native';
function DailyScratcher() {
  const dispatch = useDispatch();
  const navigation = useNavigation();
  const dailyScratcherStatus = useSelector(selectDailyScratcherStatus);
  const dailyScratcherPlayerRewardId = useSelector(
    selectDailyScratcherPlayerRewardId,
  );
  const dailyScratcherLaunchUrl = useSelector(selectDailyScratcherLaunchUrl);

  const handleFetchDailyScratcherUrl = useCallback(() => {
    if (dailyScratcherPlayerRewardId) {
      dispatch(launchDailyScratcher(dailyScratcherPlayerRewardId));
    }
  }, [dailyScratcherPlayerRewardId, dispatch]);

  const handleScratcherGameClose = useCallback(() => {
    dispatch(fetchDailyScratcher());
    dispatch(triggerAnimatedCoins());
  }, [dispatch]);

  useEffect(() => {
    if (dailyScratcherStatus === 'Pending' && dailyScratcherPlayerRewardId) {
      handleFetchDailyScratcherUrl();
    }
  }, [
    dailyScratcherStatus,
    dailyScratcherPlayerRewardId,
    handleFetchDailyScratcherUrl,
  ]);

  const handleScratcherClose = useCallback(() => {
    navigation.goBack();
  }, [navigation]);

  useEffect(() => {
    return () => {
      handleScratcherGameClose();
    };
  }, [handleScratcherGameClose]);

  if (!dailyScratcherLaunchUrl) {
    return (
      <Screen>
        <Box flex={1} justifyContent="center" alignItems="center">
          <Box width={80} height={80} marginBottom="space-600">
            <BettyCoinLoader />
          </Box>
        </Box>
      </Screen>
    );
  }

  return (
    <Box flex={1}>
      <PressableIcon
        position="absolute"
        name="close"
        width="space-600"
        height="space-600"
        gradient="accentBackground"
        backgroundColor="transparent"
        top={Platform.select({
          ios: 'space-1800',
          web: 'space-400',
          android: 'space-1800',
        })}
        marginRight={Platform.select({
          ios: 'space-400',
          web: 'space-200',
          android: 'space-400',
        })}
        alignSelf="flex-end"
        zIndex={10}
        onPress={handleScratcherClose}
      />
      <WebView
        domStorageEnabled
        javaScriptEnabled
        sharedCookiesEnabled
        cacheEnabled={!__DEV__}
        webviewDebuggingEnabled={__DEV__}
        originWhitelist={['*']}
        source={{ uri: dailyScratcherLaunchUrl }}
      />
    </Box>
  );
}
export default memo(DailyScratcher);
